export { default as EntityPlugin } from './EntityPlugin';
export { default as insertEntity } from './insertEntity';
export { default as getEntityFromElement } from './getEntityFromElement';
export { default as getEntities } from './getEntities';
export { default as getEntityElement } from './getEntityElement';
